
    // extracted by mini-css-extract-plugin
module.exports = {"container":"z1c8f4","track":"z6291e","toggle":"z29c9c","on":"ze07ba","label":"z0eed0","disabled":"z9e04d"};;
    module.exports = module.exports || {};
    module.exports.toString = function() {
      return JSON.stringify(module.exports)
    };
  